import { isToday } from 'date-fns';

import { SessionStatus } from '@/types';
import { Button, Icon } from '@/ui';

import type { Session } from '@/types';
import type { FC } from 'react';

import { useSessionJoinUrl } from '@/features/appointments/useSessionJoinUrl';

interface JoinButtonProps {
  session: Session;
}

const JoinButton: FC<JoinButtonProps> = ({ session = undefined }) => {
  const isDoneOrCancelled =
    session?.status === SessionStatus.DONE ||
    session?.status === SessionStatus.CANCELLED;

  const isSessionToday =
    !!session?.startedAt && isToday(new Date(session.startedAt));
  const joinUrl = useSessionJoinUrl(session, {
    enabled: !isDoneOrCancelled && isSessionToday,
  });
  const isValidLocation = !!joinUrl?.startsWith('https:');

  const openSession = () => {
    window.open(joinUrl);
  };

  if (isDoneOrCancelled || !isValidLocation || !isSessionToday) return null;

  const startIcon = <Icon>videocam</Icon>;
  return (
    <Button
      className="w-full md:mt-0 md:w-auto"
      color="primary"
      startIcon={startIcon}
      variant="contained"
      onClick={openSession}
    >
      Join session
    </Button>
  );
};

export default JoinButton;
